export default {
  metadata: {
    version: '1.0.0',
    id: 'menu-block-1.0.0',
    name: 'JDSMenuBlockInternal'
  },
  hierarchy: {
    container: ['jds_menu_block_item']
  },
  base: {
    container: {
      hidden: true,
      width: '{intrinsicSize.max}',
      'lazy-scroll-android': false,
      'background-color': '{primaryBackground}',
      'flex-direction': '{flexDirection.column}',
      'border-radius': '{medium}',
      overflow: 'auto',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      },
      transition: {
        property: ['max-height'],
        duration: '{slow}',
        'timing-function': '{easeExit}'
      }
    },
    jds_menu_block_item: {
      width: '{size.max}'
    }
  },
  variant: {
    open: {
      true: {
        container: {
          hidden: false,
          transition: {
            'timing-function': '{easeEntrance}'
          }
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      open: {
        values: [false, true],
        doc_description: 'Used to open or close the modal programatically.'
      }
    },
    data: {
      container: {
        'max-height': {
          type: 'size',
          name: 'maxHeight',
          function: true
        },
        'max-width': {
          type: 'size',
          name: 'maxWidth'
        },
        'min-width': {
          type: 'size',
          name: 'minWidth',
          function: true
        },
        value: {
          type: 'list',
          name: 'items',
          doc_description:
            'Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.',
          object: {
            type: 'JDSMenuBlockItem.type',
            label: 'string',
            value: 'string',
            prefix: 'icon',
            suffix: 'icon',
            disabled: 'boolean'
          }
        }
      },
      jds_menu_block_item: {
        selectedIndex: {
          type: 'number',
          name: 'selectedIndex',
          doc_description:
            'Used to programatically change current selected Index'
        },
        type: {
          type: 'string',
          name: 'items.type'
        },
        label: {
          type: 'string',
          name: 'items.label'
        },
        value: {
          type: 'string',
          name: 'items.value'
        },
        prefix: {
          type: 'icon',
          name: 'items.prefix'
        },
        suffix: {
          type: 'icon',
          name: 'items.suffix'
        },
        disabled: {
          type: 'boolean',
          name: 'items.disabled'
        },
        hasIcon: {
          type: 'boolean',
          name: '_hasIcon'
        }
      }
    },
    events: {
      jds_menu_block_item: {
        onSelect: {
          name: 'onSelect',
          doc_description:
            'onClick event that triggers upon click or tap of the chosen entry.'
        }
      },
      container: {
        onAppear: {
          name: 'onAppear',
          platform: 'ios'
        },
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        name: 'items',
        properties: {
          role: {
            value: 'menu'
          }
        },
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_menu_block_item: {
        properties: {
          ariaLabel: 'items.itemAriaLabel',
          ariaDescribedby: 'items.itemAriaDescribedby'
        }
      }
    }
  }
};
